import _ from 'lodash';
import React, { Component } from 'react';
import { animateScroll as Scroll } from 'react-scroll';

import dumbBem from 'dumb-bem';
import tx from 'transform-props-with';

import {
  FooterBlock,
  DemoForm,
} from 'components/landing/components';

import config from 'config/services';
import Header from './Header';
import SectionsList from './SectionsList';
import './Services.css';

const dumbServices = dumbBem('l-services');
const ServicesWrp = tx(dumbServices)('div');

export class Services extends Component {
  constructor(props) {
    super(props);

    this.blockRefs = {
      demoForm: React.createRef(),
      marketing: React.createRef(),
      analytics: React.createRef(),
      engineering: React.createRef(),
    };

    _.bindAll(this, [
      'scrollToDemoForm',
      'scrollToBlock',
      'scrollTo',
    ]);
  }

  scrollToDemoForm() {
    this.scrollTo(this.blockRefs.demoForm, 110);
  }

  scrollToBlock(ref) {
    this.scrollTo(ref, 80);
  }

  scrollTo(ref, offset) {
    const pos = ref.current.offsetTop - offset;
    Scroll.scrollTo(pos, { duration: 500 });
  }

  render() {
    const sections = config.contentBlocks;

    return (
      <ServicesWrp>
        <Header
          scrollToBlock={this.scrollToBlock}
          buttons={config.header.refButtons}
          title={config.header.title}
          description={config.header.description}
          blockRefs={this.blockRefs}
        />

        <SectionsList
          sections={sections}
          blockRefs={this.blockRefs}
          scrollToDemoForm={this.scrollToDemoForm}
        />

        <DemoForm
          title="Get a free analysis"
          requestBtnTitle="GET AN ANALYSIS"
          __ref={this.blockRefs.demoForm}
        />

        <FooterBlock />
      </ServicesWrp>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/landing/pages/services/Services.js